import React from "react";
import { FaEnvelope, FaFacebook, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import ImgCertificacion from "../imgs/LogoCertificación.jpeg";
import { trackWhatsAppClick } from "../utils/analytics";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-main">
          <section className="footer-brand">
            <h2>Fundación Nican A.C.</h2>
            <p>
              Cursos, diplomados y certificaciones profesionales en Ixtapaluca,
              Estado de México.
            </p>
            <img
              src={ImgCertificacion}
              alt="Logotipo de certificación de Fundación Nican"
              className="footer-cert-logo"
            />
          </section>

          <nav className="footer-links" aria-label="Enlaces del sitio">
            <h3>Enlaces</h3>
            <a href="/AvisoDePrivacidad">Aviso de Privacidad</a>
            <a href="/Conocer">CONOCER</a>
            <a href="/faq">Preguntas frecuentes</a>
            <a href="/blog">Blog</a>
            <a href="mailto:fundacionnican2020@hotmail.com?subject=Quejas%20y%20Sugerencias">
              Buzón de Quejas y Sugerencias
            </a>
          </nav>

          <section className="footer-contact">
            <h3>Contacto</h3>
            <a
              href="https://wa.me/525579118589?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20cursos%20de%20Fundaci%C3%B3n%20Nican."
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick("footer_contacto")}
            >
              <FaWhatsapp /> 55 79 11 85 89
            </a>
            <a href="mailto:fundacionnican2020@hotmail.com">
              <FaEnvelope /> fundacionnican2020@hotmail.com
            </a>
            <a
              href="https://www.facebook.com/centro.Nican"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook /> Centro Nican en Facebook
            </a>
          </section>

          <section className="footer-location">
            <h3>Ubicación</h3>
            <p>
              <FaMapMarkerAlt /> Linderos de Ixtapaluca Pozo 9, 56530
              Ixtapaluca, Estado de México.
            </p>
            <p className="footer-small-text">
              Mayor referencia: a 5 minutos del hospital de especialidades, en
              dirección a San Francisco Acuautla.
            </p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.2180142510426!2d-98.8636925!3d19.3384195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cd888c50a1532d%3A0x4ff7b6fcaeeb2c4!2sLinderos%20de%20Ixtapaluca%20Pozo%209%2C%20Ixtapaluca%2C%20Mexico%2C%2056530!5e0!3m2!1ses!2smx"
              title="Ubicación de Fundación Nican en Ixtapaluca"
              loading="lazy"
              allowFullScreen=""
            ></iframe>
          </section>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Fundación Nican A.C. Todos los derechos reservados.</p>
          <p>Formación profesional en Ixtapaluca, Chalco y Valle de Chalco.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
